// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"gJ-z","hovered":"hJ-z","hoverImage":"iJ-z","mainImage":"jJ-z","imageNoBackground":"kJ-z","fullSizeImage":"lJ-z"};